import story from '../assets/story.jpg';

export const Story = () => {
  return (
    <div className="flex flex-col overflow-x-hidden">

      {/* hero section */}

      <div className="bg-neutral-900 flex flex-col lg:flex-row">
        <div className="flex-1 mx-auto my-auto px-4 lg:px-18 xl:px-24 pt-24 lg:pt-32 pb-24">
          <h1 className="font-semibold text-white text-5xl md:text-6xl lg:text-7xl">
            <span className="text-primary ">Shriyam Foods</span>
          </h1>
          <h2 className="text-white text-3xl md:text-4xl lg:text-5xl">
            <span className="text-white ">The Story of a Foodie</span>
          </h2>
          <div className="max-w-4xl">
            <p className="mt-5 text-neutral-400 text-lg">
              It is a creative hub where imagination meets craftsmanship to transform ideas into tangible realities. At Preline Agency, we specialize in turning conceptual visions into concrete forms, whether it be through design, artistry, or technological innovation.
            </p>
          </div>
        </div>
        <div className="flex-1 flex flex-row items-center justify-center">
          <img className="w-full h-auto" src={story} alt="Image Description" />
        </div>
      </div>

      {/* section 2 */}

      <div className="relative mt-10 mb-10 overflow-hidden">
        <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="max-w-2xl text-center mx-auto">
            <h1 className="block text-3xl font-bold text-gray-800 sm:text-4xl md:text-5xl">Designed for you to get more <span className="text-primary">simple</span></h1>
         </div>

          <div className="mt-10 relative max-w-5xl mx-auto">
            <div className="w-full object-cover h-96 sm:h-[480px] bg-[url('https://images.unsplash.com/photo-1606868306217-dbf5046868d2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1981&q=80')] bg-no-repeat bg-center bg-cover rounded-xl"></div>

            <div className="absolute inset-0 size-full">
              <div className="flex flex-col justify-center items-center size-full">
                <a className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-full border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none" href="#" >
                  <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                  Play the overview
                </a>
              </div>
            </div>

            <div className="absolute bottom-12 -start-20 -z-[1] size-48 bg-gradient-to-b from-orange-500 to-white p-px rounded-lg">
              <div className="bg-white size-48 rounded-lg"></div>
            </div>

            <div className="absolute -top-12 -end-20 -z-[1] size-48 bg-gradient-to-t from-blue-600 to-cyan-400 p-px rounded-full">
              <div className="bg-white size-48 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>

      {/* testimonials */}

      <div className="max-w-6xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        <div className="flex flex-col lg:flex-row lg:gap-8 lg:items-center lg:justify-between">
          <div className="flex-3 bg-white p-4 lg:p-12">
            <div className="mb-8">
              <h2 className="mb-2 text-3xl text-gray-800 font-bold lg:text-4xl">
                It's all about speed
              </h2>
              <p className="text-gray-600">
                We provide you with a test account that can be set up in seconds. Our main focus is getting responses to you as soon as we can.
              </p>
            </div>

            <blockquote className="relative">
              <svg className="absolute top-0 start-0 transform -translate-x-6 -translate-y-8 size-16 text-gray-200" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.69067 8.45999C7.16197 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9173 8.45999C14.3886 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor"/>
              </svg>

              <div className="relative z-10">
                <p className="text-xl italic text-gray-800">
                  Amazing people to work with. Very fast and professional partner.
                </p>
              </div>

              <footer className="mt-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <img className="size-8 rounded-full" src="https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=320&h=320&q=80" alt="Image Description" />
                  </div>
                  <div className="grow ms-4">
                    <div className="font-semibold text-gray-800">Josh Grazioso</div>
                    <div className="text-xs text-gray-500">Director Payments & Risk | Airbnb</div>
                  </div>
                </div>
              </footer>
            </blockquote>
          </div>

          <div className="mt-10 ml-auto lg:mt-0 flex-5">
            <div className="space-y-6 sm:space-y-8">
              <ul className="grid grid-cols-2 divide-y divide-y-2 divide-x divide-x-2 divide-gray-200 overflow-hidden">
                <li className="flex flex-col -m-0.5 p-4 sm:p-8">
                  <div className="flex items-end gap-x-2 text-3xl sm:text-5xl font-bold text-gray-800 mb-2">
                    45k+
                  </div>
                  <p className="text-sm sm:text-base text-gray-600">
                    users - from new startups to public companies
                  </p>
                </li>

                <li className="flex flex-col -m-0.5 p-4 sm:p-8">
                  <div className="flex items-end gap-x-2 text-3xl sm:text-5xl font-bold text-gray-800 mb-2">
                    <svg className="flex-shrink-0 size-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 7-7 7 7"/><path d="M12 19V5"/></svg>
                    23%
                  </div>
                  <p className="text-sm sm:text-base text-gray-600">
                    increase in traffic on webpages with Looms
                  </p>
                </li>

                <li className="flex flex-col -m-0.5 p-4 sm:p-8">
                  <div className="flex items-end gap-x-2 text-3xl sm:text-5xl font-bold text-gray-800 mb-2">
                    <svg className="flex-shrink-0 size-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 7-7 7 7"/><path d="M12 19V5"/></svg>
                    9.3%
                  </div>
                  <p className="text-sm sm:text-base text-gray-600">
                    boost in reply rates across sales outreach
                  </p>
                </li>

                <li className="flex flex-col -m-0.5 p-4 sm:p-8">
                  <div className="flex items-end gap-x-2 text-3xl sm:text-5xl font-bold text-gray-800 mb-2">
                    2x
                  </div>
                  <p className="text-sm sm:text-base text-gray-600">
                    faster than previous Preline versions
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* stats */}

      <div className="px-4 relative max-w-6xl min-w-[65vw] xl:px-0 py-10 mx-auto">

        <div className="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
          <h2 className="text-2xl font-bold md:text-3xl md:leading-tight text-gray-800">
            Our Amazing Stats
          </h2>
        </div>

        <svg className="absolute -bottom-20 start-1/2 w-[1900px] transform -translate-x-1/2" width="2745" height="488" viewBox="0 0 2745 488" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 330.864C232.505 403.801 853.749 527.683 1482.69 439.719C2111.63 351.756 2585.54 434.588 2743.87 487" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 308.873C232.505 381.81 853.749 505.692 1482.69 417.728C2111.63 329.765 2585.54 412.597 2743.87 465.009" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 286.882C232.505 359.819 853.749 483.701 1482.69 395.738C2111.63 307.774 2585.54 390.606 2743.87 443.018" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 264.891C232.505 337.828 853.749 461.71 1482.69 373.747C2111.63 285.783 2585.54 368.615 2743.87 421.027" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 242.9C232.505 315.837 853.749 439.719 1482.69 351.756C2111.63 263.792 2585.54 346.624 2743.87 399.036" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 220.909C232.505 293.846 853.749 417.728 1482.69 329.765C2111.63 241.801 2585.54 324.633 2743.87 377.045" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 198.918C232.505 271.855 853.749 395.737 1482.69 307.774C2111.63 219.81 2585.54 302.642 2743.87 355.054" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 176.927C232.505 249.864 853.749 373.746 1482.69 285.783C2111.63 197.819 2585.54 280.651 2743.87 333.063" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 154.937C232.505 227.873 853.749 351.756 1482.69 263.792C2111.63 175.828 2585.54 258.661 2743.87 311.072" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 132.946C232.505 205.882 853.749 329.765 1482.69 241.801C2111.63 153.837 2585.54 236.67 2743.87 289.082" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 110.955C232.505 183.891 853.749 307.774 1482.69 219.81C2111.63 131.846 2585.54 214.679 2743.87 267.091" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 88.9639C232.505 161.901 853.749 285.783 1482.69 197.819C2111.63 109.855 2585.54 192.688 2743.87 245.1" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 66.9729C232.505 139.91 853.749 263.792 1482.69 175.828C2111.63 87.8643 2585.54 170.697 2743.87 223.109" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 44.9819C232.505 117.919 853.749 241.801 1482.69 153.837C2111.63 65.8733 2585.54 148.706 2743.87 201.118" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 22.991C232.505 95.9276 853.749 219.81 1482.69 131.846C2111.63 43.8824 2585.54 126.715 2743.87 179.127" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 1C232.505 73.9367 853.749 197.819 1482.69 109.855C2111.63 21.8914 2585.54 104.724 2743.87 157.136" className="stroke-gray-100/5" stroke="currentColor"/>
        </svg>

        <div className="border border-neutral-800">
          <div className="p-4 lg:p-8 bg-primaryDark">
            <div className="grid grid-cols-1 sm:grid-cols-3 items-center gap-y-20 gap-x-12">
              <div className="relative text-center first:before:hidden before:absolute before:-top-full sm:before:top-1/2 before:start-1/2 sm:before:-start-6 before:w-px before:h-20 before:bg-neutral-800 before:rotate-[60deg] sm:before:rotate-12 before:transform sm:before:-translate-y-1/2 before:-translate-x-1/2 sm:before:-translate-x-0 before:mt-3.5 sm:before:mt-0">
                <svg className="flex-shrink-0 size-6 sm:size-8 text-[#ff0] mx-auto" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3 1 11h-2"/><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/><path d="M3 4h8"/></svg>
                <div className="mt-3 sm:mt-5">
                  <h3 className="text-lg sm:text-3xl font-semibold text-white">2,000+</h3>
                  <p className="mt-3 text-md sm:text-base text-neutral-200">Orders</p>
                </div>
              </div>

              <div className="relative text-center first:before:hidden before:absolute before:-top-full sm:before:top-1/2 before:start-1/2 sm:before:-start-6 before:w-px before:h-20 before:bg-white before:rotate-[60deg] sm:before:rotate-12 before:transform sm:before:-translate-y-1/2 before:-translate-x-1/2 sm:before:-translate-x-0 before:mt-3.5 sm:before:mt-0">
                <div className="flex justify-center items-center -space-x-5">
                  <img className="relative z-[2] flex-shrink-0 size-8 rounded-full border-[3px] border-neutral-800" src="https://images.unsplash.com/photo-1601935111741-ae98b2b230b0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=320&h=320&q=80" alt="" />
                  <img className="relative z-[1] flex-shrink-0 size-8 rounded-full border-[3px] border-neutral-800 -mt-7" src="https://images.unsplash.com/photo-1570654639102-bdd95efeca7a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=320&h=320&q=80" alt="" />
                  <img className="relative flex-shrink-0 size-8 rounded-full border-[3px] border-neutral-800" src="https://images.unsplash.com/photo-1679412330254-90cb240038c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2.5&w=320&h=320&q=80" alt="" />
                </div>
                <div className="mt-3 sm:mt-5">
                  <h3 className="text-lg sm:text-3xl font-semibold text-white">99%</h3>
                  <p className="mt-3 text-md sm:text-base text-neutral-200">Happy customers</p>
                </div>
              </div>

              <div className="relative text-center first:before:hidden before:absolute before:-top-full sm:before:top-1/2 before:start-1/2 sm:before:-start-6 before:w-px before:h-20 before:bg-white before:rotate-[60deg] sm:before:rotate-12 before:transform sm:before:-translate-y-1/2 before:-translate-x-1/2 sm:before:-translate-x-0 before:mt-3.5 sm:before:mt-0">
                <svg className="flex-shrink-0 size-6 sm:size-8 text-[#ff0] mx-auto" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"/><path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/><path d="m2 16 6 6"/><circle cx="16" cy="9" r="2.9"/><circle cx="6" cy="5" r="3"/></svg>
                <div className="mt-3 sm:mt-5">
                  <h3 className="text-lg sm:text-3xl font-semibold text-white">₹ 45k</h3>
                  <p className="mt-3 text-md sm:text-base text-neutral-200">Average Monthly Order</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* faq */}

      <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        <div className="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
          <h2 className="text-2xl font-bold md:text-3xl md:leading-tight text-gray-800">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
            <div className="bg-white p-5">
              <h3 className="text-lg font-semibold text-gray-800">
                Can I cancel at anytime?
              </h3>
              <p className="mt-2 text-gray-600">
                Yes, you can cancel anytime no questions are asked while you cancel but we would highly appreciate if you will give us some feedback.
              </p>
            </div>

            <div className="bg-white p-5">
              <h3 className="text-lg font-semibold text-gray-800">
                My team has credits. How do we use them?
              </h3>
              <p className="mt-2 text-gray-600">
                Once your team signs up for a subscription plan. This is where we sit down, grab a cup of coffee and dial in the details.
              </p>
            </div>

            <div className="bg-white p-5">
              <h3 className="text-lg font-semibold text-gray-800">
                How does Preline's pricing work?
              </h3>
              <p className="mt-2 text-gray-600">
                Our subscriptions are tiered. Understanding the task at hand and ironing out the wrinkles is key.
              </p>
            </div>

            <div className="bg-white p-5">
              <h3 className="text-lg font-semibold text-gray-800">
                How secure is Preline?
              </h3>
              <p className="mt-2 text-gray-600">
                Protecting the data you trust to Preline is our first priority. This part is really crucial in keeping the project in line to completion.
              </p>
            </div>

            <div className="bg-white p-5">
              <h3 className="text-lg font-semibold text-gray-800">
                Do you offer discounts?
              </h3>
              <p className="mt-2 text-gray-600">
                We've built in discounts at each tier for teams. The time has come to bring those ideas and plans to life.
              </p>
            </div>

            <div className="bg-white p-5">
              <h3 className="text-lg font-semibold text-gray-800">
                What is your refund policy?
              </h3>
              <p className="mt-2 text-gray-600">
                We offer refunds. We aim high at being focused on building relationships with our clients and community.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* footer */}

      <footer className="fixed z-[999] left-0 bottom-0 overflow-hidden bg-primaryDark w-screen">
        <svg className="absolute -bottom-20 start-1/2 w-[1900px] transform -translate-x-1/2" width="2745" height="488" viewBox="0 0 2745 488" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 330.864C232.505 403.801 853.749 527.683 1482.69 439.719C2111.63 351.756 2585.54 434.588 2743.87 487" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 308.873C232.505 381.81 853.749 505.692 1482.69 417.728C2111.63 329.765 2585.54 412.597 2743.87 465.009" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 286.882C232.505 359.819 853.749 483.701 1482.69 395.738C2111.63 307.774 2585.54 390.606 2743.87 443.018" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 264.891C232.505 337.828 853.749 461.71 1482.69 373.747C2111.63 285.783 2585.54 368.615 2743.87 421.027" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 242.9C232.505 315.837 853.749 439.719 1482.69 351.756C2111.63 263.792 2585.54 346.624 2743.87 399.036" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 220.909C232.505 293.846 853.749 417.728 1482.69 329.765C2111.63 241.801 2585.54 324.633 2743.87 377.045" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 198.918C232.505 271.855 853.749 395.737 1482.69 307.774C2111.63 219.81 2585.54 302.642 2743.87 355.054" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 176.927C232.505 249.864 853.749 373.746 1482.69 285.783C2111.63 197.819 2585.54 280.651 2743.87 333.063" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 154.937C232.505 227.873 853.749 351.756 1482.69 263.792C2111.63 175.828 2585.54 258.661 2743.87 311.072" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 132.946C232.505 205.882 853.749 329.765 1482.69 241.801C2111.63 153.837 2585.54 236.67 2743.87 289.082" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 110.955C232.505 183.891 853.749 307.774 1482.69 219.81C2111.63 131.846 2585.54 214.679 2743.87 267.091" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 88.9639C232.505 161.901 853.749 285.783 1482.69 197.819C2111.63 109.855 2585.54 192.688 2743.87 245.1" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 66.9729C232.505 139.91 853.749 263.792 1482.69 175.828C2111.63 87.8643 2585.54 170.697 2743.87 223.109" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 44.9819C232.505 117.919 853.749 241.801 1482.69 153.837C2111.63 65.8733 2585.54 148.706 2743.87 201.118" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 22.991C232.505 95.9276 853.749 219.81 1482.69 131.846C2111.63 43.8824 2585.54 126.715 2743.87 179.127" className="stroke-gray-100/5" stroke="currentColor"/>
          <path d="M0.5 1C232.505 73.9367 853.749 197.819 1482.69 109.855C2111.63 21.8914 2585.54 104.724 2743.87 157.136" className="stroke-gray-100/5" stroke="currentColor"/>
        </svg>

        <div className="relative z-10 py-2 w-screen">
          <div className="w-screen px-4 xl:px-0 py-6 mx-auto">
            <div className="inline-flex px-12 w-full items-center">
              <div className="border-s flex flex-col md:flex-row w-full border-neutral-700 ps-5 ms-5">
                <p className="text-2xl text-white text-bold">Shriyan Foods, <span className="text-xl text-white opacity-[0.55] ml-2 text-bold">2024</span></p>
                <p className="text-2xl text-white text-bold mr-auto md:mr-0 ml-auto"><span className="text-xl text-white opacity-[0.55] -ml-2 md:ml-0 text-bold">admin@shriyamfoods.com</span></p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* spacer */}

      <div className="h-[120px] w-full"></div>

    </div>
  )
}